import { useEffect, useRef, type MutableRefObject } from 'react';

interface DispatchFunction {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (...args: any[]): void;
}

const useWhenMounted = (): {
  isMounted: MutableRefObject<boolean>;
  whenMounted: (dispatch: DispatchFunction) => DispatchFunction;
} => {
  const isMounted: MutableRefObject<boolean> = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  // This higher-order function produces a dispatch function that
  // only invokes when it's parent component is mounted.
  const whenMounted = (dispatch: DispatchFunction): DispatchFunction => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return ((...args) => {
      if (isMounted.current) {
        return dispatch(...args);
      }
    }) as DispatchFunction;
  };

  return { isMounted, whenMounted };
};

export default useWhenMounted;
